var map = {
	"./404-not-found.jpg": 514,
	"./Affiliate-Banner-Mobile.jpg": 1212,
	"./Affiliate-Banner-desktop.jpg": 1213,
	"./Bank.svg": 1214,
	"./Deposit-new-icon.svg": 1215,
	"./Deposit_Now_Icon.svg": 319,
	"./GiftCard/GiftImg.png": 663,
	"./GiftCard/bro.png": 664,
	"./GiftCard/superGiftImg.webp": 748,
	"./Hamburger.svg": 1216,
	"./Promotion/Promotion-Image.jpeg": 1217,
	"./Racebook.svg": 749,
	"./Roketlogo.png": 750,
	"./advance.png": 751,
	"./advance.svg": 1218,
	"./affiliate/247-Customer-Support.png": 676,
	"./affiliate/Easy-Accessible-Efficient.png": 677,
	"./affiliate/Hefty-Commissions-94x94.png": 678,
	"./affiliate/Multi-Tier-System.png": 679,
	"./affiliate/Offerings.png": 680,
	"./affiliate/affiliate-banner-900x750.jpg": 1219,
	"./affiliate/stay-up-to-date-94x94.png": 681,
	"./android.png": 752,
	"./appstore.png": 753,
	"./astropay.png": 754,
	"./bank.png": 755,
	"./betfair-logo.png": 756,
	"./bkash.png": 757,
	"./bonus.png": 682,
	"./btc.svg": 659,
	"./casino-cards.png": 758,
	"./casino-modal.png": 655,
	"./casino.png": 759,
	"./coins.jpg": 1220,
	"./copy.svg": 656,
	"./crash_games/aviat.png": 683,
	"./crash_games/crash_bonus.png": 684,
	"./crash_games/football_manager.png": 685,
	"./crash_games/go_rush.png": 686,
	"./crash_games/keno.png": 687,
	"./crash_games/limbo.png": 688,
	"./crash_games/mines.png": 689,
	"./crash_games/mines_gold.png": 690,
	"./crash_games/plinko.png": 691,
	"./crash_games/tower.png": 692,
	"./crash_games/wheel.png": 693,
	"./credit-card.png": 760,
	"./credit-card.svg": 1221,
	"./crypto.png": 761,
	"./crypto.svg": 694,
	"./depositPageIcons/bhim-logo.jpg": 1222,
	"./depositPageIcons/bhim.png": 762,
	"./depositPageIcons/bhim_logo.jpg": 1223,
	"./depositPageIcons/card_waves.png": 763,
	"./depositPageIcons/google-pay-logo.jpg": 1224,
	"./depositPageIcons/google-pay.png": 764,
	"./depositPageIcons/google_pay_logo.jpg": 1225,
	"./depositPageIcons/pay-tm-logo.jpg": 1226,
	"./depositPageIcons/pay_tm_logo.jpg": 1227,
	"./depositPageIcons/paytm.png": 765,
	"./depositPageIcons/phonepe-logo.jpg": 1228,
	"./depositPageIcons/phonepe.png": 766,
	"./depositPageIcons/phonepe_logo.jpg": 1229,
	"./depositPageIcons/upi-logo.jpg": 1230,
	"./depositPageIcons/upi_logo.jpg": 1231,
	"./depositPageIcons/upi_logo.png": 665,
	"./diamond-logo.png": 767,
	"./download-apk-md.png": 695,
	"./download-apk-mobile.png": 696,
	"./download-apk-pc.png": 697,
	"./downloadapp/Download-app-Image.jpg": 1232,
	"./downloadapp/Download-app-Images.jpg": 1233,
	"./drawer/Affiliate-white.svg": 518,
	"./drawer/about-us.png": 404,
	"./drawer/about-us.svg": 519,
	"./drawer/affiliate.png": 405,
	"./drawer/affiliate.webp": 520,
	"./drawer/arrow-down.png": 406,
	"./drawer/bet_pnl.png": 407,
	"./drawer/blogs.png": 408,
	"./drawer/change_no.png": 409,
	"./drawer/faqs.png": 410,
	"./drawer/faqs.svg": 521,
	"./drawer/favorites.png": 411,
	"./drawer/feedback.png": 258,
	"./drawer/help.svg": 522,
	"./drawer/loyalty.png": 412,
	"./drawer/loyalty.svg": 523,
	"./drawer/market.png": 413,
	"./drawer/market.svg": 524,
	"./drawer/news.png": 414,
	"./drawer/news.svg": 525,
	"./drawer/notification.png": 415,
	"./drawer/online-betting-app.svg": 526,
	"./drawer/open_bets.png": 416,
	"./drawer/privacy.png": 417,
	"./drawer/privacy.svg": 527,
	"./drawer/profile.png": 418,
	"./drawer/promotions.png": 419,
	"./drawer/promotions.svg": 528,
	"./drawer/reset_password.png": 420,
	"./drawer/rules.png": 421,
	"./drawer/settings.png": 422,
	"./drawer/terms-and-conditions.png": 423,
	"./drawer/terms-and-conditions.svg": 529,
	"./drawer/transactions.png": 424,
	"./drawer/wallet.png": 425,
	"./drop.png": 658,
	"./fairplay-book-Logo.png": 768,
	"./fairplay-book-desktop.jpg": 698,
	"./fairplay-book-mobile.jpg": 699,
	"./fairplay-logo.png": 444,
	"./fav_star.svg": 1234,
	"./features/account_box.png": 769,
	"./features/betting-app-left-banner.png": 770,
	"./features/betting_box.png": 771,
	"./features/feature01.png": 772,
	"./features/feature02.png": 773,
	"./features/feature02_old.png": 774,
	"./features/feature03.png": 775,
	"./features/feature04-old.png": 776,
	"./features/feature04.png": 777,
	"./features/feature1-new.png": 700,
	"./features/feature2-new.png": 778,
	"./features/feature3-new.png": 779,
	"./features/feature4-new.png": 780,
	"./features/how-to-register.png": 781,
	"./features/leftside-banner-new.jpg": 1235,
	"./features/leftside-banner.jpg": 1236,
	"./features/offers_box.png": 782,
	"./features/otp_page.png": 783,
	"./features/security_box.png": 784,
	"./features/wallet_box.png": 785,
	"./finsa-banner.png": 701,
	"./game-providers/bcoongo.png": 702,
	"./game-providers/bet-games.png": 703,
	"./game-providers/bet-soft.png": 704,
	"./game-providers/evolution-gaming.png": 705,
	"./game-providers/ezugi.svg": 786,
	"./game-providers/ibetsoft.png": 706,
	"./game-providers/microgaming.png": 707,
	"./game-providers/pgsoft.png": 708,
	"./game-providers/realtime-gaming.png": 709,
	"./game-providers/sa-gaming.png": 710,
	"./game-providers/sportsradar1.png": 711,
	"./game-providers/super-spades.png": 712,
	"./game-providers/vivo.jpeg": 787,
	"./game-providers/vivo.png": 713,
	"./game-providers/xpg1.png": 714,
	"./games/32-cards.jpg": 788,
	"./games/7up7down.jpg": 789,
	"./games/AAA-new.png": 790,
	"./games/Andar-Bahar-new.png": 791,
	"./games/Baccarat-new.png": 792,
	"./games/Black-Jack-new.png": 793,
	"./games/Cricket-new.png": 794,
	"./games/Dragon-Tiger-new.png": 795,
	"./games/Dream-Catcher-new.png": 796,
	"./games/Football-new.png": 797,
	"./games/Poker-new.png": 798,
	"./games/Speed-Roulette-new.png": 799,
	"./games/Teen-Patti-Live-new.png": 800,
	"./games/Tennis-new.png": 801,
	"./games/aaa.jpg": 802,
	"./games/andar_bahar.jpg": 803,
	"./games/baccarat.jpg": 804,
	"./games/blackjack.jpg": 805,
	"./games/bollywood_casino.jpg": 806,
	"./games/cricket.jpg": 807,
	"./games/dragon_tiger.jpg": 808,
	"./games/dream_catcher.jpg": 809,
	"./games/football.jpg": 810,
	"./games/pokeer_6players.jpg": 811,
	"./games/poker.jpg": 812,
	"./games/race-20-20.jpg": 813,
	"./games/speed_roulette.jpg": 814,
	"./games/teen-patti_T20.jpg": 815,
	"./games/teen-patti_one-day.jpg": 816,
	"./games/tennis.jpg": 817,
	"./games/worli-matka.jpg": 818,
	"./google-icon.svg": 660,
	"./green-circle-tick.png": 715,
	"./how-to-deposit.mp4": 819,
	"./icon_192x192.png": 820,
	"./icon_512x512.png": 821,
	"./illustrations/illustration01.png": 822,
	"./illustrations/illustration02.svg": 1237,
	"./illustrations/illustrationold02.png": 823,
	"./index/live-cards-banner.gif": 1238,
	"./index/live-cards-banner2.gif": 716,
	"./index/live-cards-mob.gif": 717,
	"./index/live-casino-banner-mobile.gif": 1239,
	"./index/live-casino-banner.gif": 1240,
	"./index/live-casino-banner2.gif": 718,
	"./index/live-casino-mob.gif": 719,
	"./index/premium-new.gif": 1241,
	"./index/premium.gif": 720,
	"./index/premium_old.gif": 1242,
	"./info.svg": 226,
	"./inplayico.png": 666,
	"./inplayico.webp": 1243,
	"./landingpage/Pattern-Background.jpg": 1244,
	"./landingpage/Pattern-mob-Background.jpg": 1245,
	"./landingpage/Pattern.png": 824,
	"./learn-icon.png": 825,
	"./light-pattern.jpg": 611,
	"./line-line.svg": 608,
	"./live-games/2-card-teenpatti.png": 721,
	"./live-games/2-card-teenpatti.webp": 826,
	"./live-games/32-card-casino.png": 722,
	"./live-games/32-card-casino.webp": 827,
	"./live-games/amar-akbar.png": 723,
	"./live-games/amar-akbar.webp": 828,
	"./live-games/andar-bahar.png": 724,
	"./live-games/andar-bahar.webp": 829,
	"./live-games/crazy-time.png": 725,
	"./live-games/crazy-time.webp": 830,
	"./live-games/deal-no-deal.png": 726,
	"./live-games/deal-no-deal.webp": 831,
	"./live-games/dragon-tiger.png": 727,
	"./live-games/dragon-tiger.webp": 832,
	"./live-games/hi-lo.png": 728,
	"./live-games/hi-lo.webp": 833,
	"./live-games/lightning-dice.png": 729,
	"./live-games/lightning-dice.webp": 834,
	"./live-games/money-wheel.png": 730,
	"./live-games/money-wheel.webp": 835,
	"./live-games/roulette.png": 731,
	"./live-games/roulette.webp": 836,
	"./live-games/teenpatti.png": 732,
	"./live-games/teenpatti.webp": 837,
	"./livecards/card-32cardcasino.jpg": 1246,
	"./livecards/card-7updown.jpg": 1247,
	"./livecards/card-aamar-akbar.jpg": 1248,
	"./livecards/card-andarbhar.jpg": 1249,
	"./livecards/card-dragon-tiger.jpg": 1250,
	"./livecards/card-poker.jpg": 1251,
	"./livecards/card-teenpatti.jpg": 1252,
	"./livecards/card-teenpatti20-live.jpg": 1253,
	"./livecards/casino-meter.jpg": 1254,
	"./livecards/cg_6player_poker.jpg": 1255,
	"./livecards/cg_baccarat.jpg": 1256,
	"./livecards/cg_blackjack.jpg": 1257,
	"./livecards/cg_bollywoodcasino.jpg": 1258,
	"./livecards/cg_cricket.jpg": 1259,
	"./livecards/cg_dreamcatcher.jpg": 1260,
	"./livecards/cg_football.jpg": 1261,
	"./livecards/cg_race20_20.jpg": 1262,
	"./livecards/cg_speed_roulette_live.jpg": 1263,
	"./livecards/cg_tennis.jpg": 1264,
	"./livecards/cg_worlimatka.jpg": 1265,
	"./livecards/hi-low.jpg": 1266,
	"./livecards/muflis-teenpatti.jpg": 1267,
	"./loader/loader.gif": 1268,
	"./login-bg.jpg": 1269,
	"./logo-lg.png": 838,
	"./logo.png": 839,
	"./logo/betfair-logo.png": 840,
	"./logo/logo-lg.png": 841,
	"./logo/logo.png": 842,
	"./logo/website-logo.png": 443,
	"./loyalty/Crown.png": 427,
	"./loyalty/Loyalty-Plan.jpg": 1270,
	"./loyalty/arrow-black.png": 428,
	"./loyalty/arrow-white.png": 429,
	"./loyalty/blue-bg.png": 430,
	"./loyalty/blue-loyalty-card.png": 431,
	"./loyalty/blue-loyalty.png": 379,
	"./loyalty/card-bg.png": 432,
	"./loyalty/gold-bg.png": 433,
	"./loyalty/gold-loyalty-card.png": 434,
	"./loyalty/gold-loyalty.png": 380,
	"./loyalty/left-blue.jpg": 601,
	"./loyalty/left-blue.png": 207,
	"./loyalty/left-gold.jpg": 603,
	"./loyalty/left-platinum.jpg": 604,
	"./loyalty/left-silver.jpg": 602,
	"./loyalty/only-blue-bg.png": 435,
	"./loyalty/only-gold-bg.png": 436,
	"./loyalty/only-platinum-bg.png": 437,
	"./loyalty/only-silver-bg.png": 438,
	"./loyalty/platinum-bg.png": 439,
	"./loyalty/platinum-loyalty-card.png": 440,
	"./loyalty/platinum-loyalty.png": 381,
	"./loyalty/silver-bg.png": 441,
	"./loyalty/silver-loyalty-card.png": 442,
	"./loyalty/silver-loyalty.png": 382,
	"./ltc.svg": 733,
	"./menu.png": 843,
	"./menu/Basket-Ball.png": 844,
	"./menu/Cricket.png": 845,
	"./menu/Finance-Trading.png": 846,
	"./menu/Horse-Racing.png": 734,
	"./menu/Inplay.png": 847,
	"./menu/Live-Card.png": 848,
	"./menu/Live-Casino.png": 849,
	"./menu/Premium-Notebook.png": 850,
	"./menu/Slot-Games.png": 851,
	"./menu/Soccer.png": 852,
	"./menu/Sportsbook.png": 853,
	"./menu/Tennis.png": 854,
	"./menu/cardicon.png": 855,
	"./menu/sportsbook/american_football.png": 445,
	"./menu/sportsbook/badminton.png": 446,
	"./menu/sportsbook/baseball.png": 447,
	"./menu/sportsbook/basketball.png": 448,
	"./menu/sportsbook/bowls.png": 449,
	"./menu/sportsbook/boxing.png": 450,
	"./menu/sportsbook/counter_strike.png": 451,
	"./menu/sportsbook/cricket.png": 452,
	"./menu/sportsbook/cycling.png": 453,
	"./menu/sportsbook/darts.png": 454,
	"./menu/sportsbook/dota_2.png": 455,
	"./menu/sportsbook/e_cricket.png": 456,
	"./menu/sportsbook/e_fighting.png": 457,
	"./menu/sportsbook/fifa.png": 458,
	"./menu/sportsbook/fifa_volta.png": 459,
	"./menu/sportsbook/formula1.png": 460,
	"./menu/sportsbook/golf.png": 461,
	"./menu/sportsbook/handball.png": 462,
	"./menu/sportsbook/ice_hokey.png": 463,
	"./menu/sportsbook/motorcycle_racing.png": 464,
	"./menu/sportsbook/nba2k19.png": 465,
	"./menu/sportsbook/rugby.png": 466,
	"./menu/sportsbook/snooker.png": 467,
	"./menu/sportsbook/soccer.png": 468,
	"./menu/sportsbook/tabletennis.png": 469,
	"./menu/sportsbook/tennis.png": 470,
	"./menu/sportsbook/volleyball.png": 471,
	"./menu/sportsbook/waterpolo.png": 472,
	"./nagad.png": 856,
	"./premium-bg.svg": 1271,
	"./premium-sport-logo.png": 857,
	"./profile.svg": 607,
	"./promo_code.svg": 735,
	"./promotion-banner-desktop.jpg": 1272,
	"./promotion-banner-mobile.jpg": 1273,
	"./purse.png": 259,
	"./referandearn.png": 858,
	"./referandearn1.png": 859,
	"./register-whatsapp.png": 255,
	"./slider.jpg": 1274,
	"./sportsbook-categories/badminton.png": 353,
	"./sportsbook-categories/baseball.png": 354,
	"./sportsbook-categories/basketball.png": 355,
	"./sportsbook-categories/binary.png": 384,
	"./sportsbook-categories/boxing.png": 356,
	"./sportsbook-categories/cardicon.png": 357,
	"./sportsbook-categories/casino.png": 358,
	"./sportsbook-categories/crash_games.png": 385,
	"./sportsbook-categories/cricket.png": 386,
	"./sportsbook-categories/cs.png": 359,
	"./sportsbook-categories/dota.png": 360,
	"./sportsbook-categories/efighting.png": 361,
	"./sportsbook-categories/election.png": 387,
	"./sportsbook-categories/fifa.png": 362,
	"./sportsbook-categories/formula.png": 363,
	"./sportsbook-categories/golf.png": 364,
	"./sportsbook-categories/greyhound-racing.png": 388,
	"./sportsbook-categories/greyhound.png": 365,
	"./sportsbook-categories/horse-racing.png": 389,
	"./sportsbook-categories/horse.png": 366,
	"./sportsbook-categories/inplay.png": 390,
	"./sportsbook-categories/kabaddi.jpg": 860,
	"./sportsbook-categories/kabaddi.png": 367,
	"./sportsbook-categories/live-card.png": 391,
	"./sportsbook-categories/live-casino.png": 392,
	"./sportsbook-categories/lottery.png": 393,
	"./sportsbook-categories/more.png": 394,
	"./sportsbook-categories/premium-notebook.png": 395,
	"./sportsbook-categories/raceicon.png": 396,
	"./sportsbook-categories/rugby.png": 368,
	"./sportsbook-categories/slot-games.png": 397,
	"./sportsbook-categories/sloticon.png": 369,
	"./sportsbook-categories/sloticon1.png": 398,
	"./sportsbook-categories/soccer.png": 399,
	"./sportsbook-categories/sportsbook.png": 400,
	"./sportsbook-categories/table-tennis.png": 370,
	"./sportsbook-categories/tennis.png": 401,
	"./sportsbook-categories/virtual.png": 371,
	"./sportsbook-categories/voleyball.png": 372,
	"./survey.svg": 1275,
	"./telegram.svg": 1276,
	"./telegramapp.svg": 1277,
	"./thanks-modified.png": 667,
	"./trx.svg": 736,
	"./upcomingico.png": 668,
	"./upcomingico.webp": 1278,
	"./upload-sign.svg": 737,
	"./upload.svg": 861,
	"./usdt.svg": 738,
	"./utr_id_images.svg": 739,
	"./utr_upload.svg": 862,
	"./wallet-bank.png": 863,
	"./wallet-crypto.png": 864,
	"./wallet-payment-methods.png": 865,
	"./wallet-primary.svg": 740,
	"./wallet.svg": 320,
	"./whatsApp.svg": 741,
	"./whatsapp.png": 866,
	"./whatsapp_pay.png": 669,
	"./whatsup-icon1.svg": 1279,
	"./world-logo.png": 867,
	"./wpng.png": 868,
	"./xrp.svg": 742
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1211;